import { supabase } from "@/shared/lib/supabase";
import { getImpersonationContext } from "@/shared/utils/impersonation";
import type { ActionType, ActorType } from "@/shared/types/activityLog";

export interface ActivityLogPayload {
  estate_id: number;
  action_type: ActionType;
  actor_type?: ActorType;
  user_id?: number | null;
  entity_type?: string | null;
  entity_id?: string | null;
  metadata?: Record<string, unknown>;
}

export async function logActivity(payload: ActivityLogPayload): Promise<void> {
  const impersonation = getImpersonationContext();

  if (impersonation) {
    const { error } = await supabase.functions.invoke("impersonation/log", {
      body: {
        token: impersonation.token,
        estate_id: payload.estate_id,
        action_type: payload.action_type,
        user_id: payload.user_id ?? null,
        entity_type: payload.entity_type ?? null,
        entity_id: payload.entity_id ?? null,
        metadata: payload.metadata ?? {},
      },
    });

    if (error) {
      console.error("Failed to log activity:", error);
    }
    return;
  }

  const { error } = await supabase.from("activity_logs").insert({
    estate_id: payload.estate_id,
    action_type: payload.action_type,
    actor_type: payload.actor_type ?? "user",
    admin_id: null,
    user_id: payload.user_id ?? null,
    entity_type: payload.entity_type ?? null,
    entity_id: payload.entity_id ?? null,
    metadata: payload.metadata ?? {},
  });

  if (error) {
    console.error("Failed to log activity:", error);
  }
}
